import { render, staticRenderFns } from "./reisetermin-view-tab-default.vue?vue&type=template&id=497bb528&scoped=true"
import script from "./reisetermin-view-tab-default.vue?vue&type=script&lang=js"
export * from "./reisetermin-view-tab-default.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-view-tab-default.vue?vue&type=style&index=0&id=497bb528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bb528",
  null
  
)

export default component.exports